<!--
 * @Author: Lemon C
 * @Date: 2024-05-15 12:25:19
 * @LastEditTime: 2025-03-14 15:23:04
-->
<template>
    <div class="sup-msg-cont-comp">
        <span class="top-tip" v-if="msg_list_item && msg_list_item.message && msg_list_item.message.length > 0">{{ top_tip }}</span>
        <div class="title-box" v-if="msg_list_item && msg_list_item.message && msg_list_item.message.length > 0">
            <span class="title-name">{{ msg_list_item.title }}</span>
            <span class="update-time" v-if="update_time_computed.length">{{ update_time_computed }}</span>
        </div>
        <!-- <span class="title-box" v-if="msg_list_item && msg_list_item.message && msg_list_item.message.length > 0">{{ top_tip }}</span> -->
        <div class="msg-cont-md" v-if="msg_list_item && msg_list_item.message && msg_list_item.message.length > 0" @click="md_handle_link_click">
            <md-preview :editorId="md_preview_id" :modelValue="msg_list_item.message" previewTheme="github" :codeFoldable="false" />
        </div>
        <el-empty class="msg-cont-md-empty" v-else description="暂无消息" />
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, watch, computed } from 'vue';
import { MdPreview } from 'md-editor-v3';
import 'md-editor-v3/lib/preview.css';
import { formatTime } from '@/utils/generalMethods';

const props = defineProps({
    msg_list_item: Object,
});

const md_preview_id = ref('preview-only');

watch(
    () => props.msg_list_item,
    () => {},
    {
        deep: true,
    }
);

const top_tip = computed(() => {
    return props.msg_list_item && props.msg_list_item.message && props.msg_list_item.message.length > 0 ? '关于开发者中心的一条通知' : '暂无消息';
});

const update_time_computed = computed(() => {
    let timeStr = '';
    if (props.msg_list_item.publishTime && props.msg_list_item.publishTime.length > 0) {
        timeStr = '' + formatTime(props.msg_list_item.publishTime);
    }
    return timeStr;
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-msg-cont-comp {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 10px 48px 10px 40px;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;

    .top-tip {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 70px;
        font-weight: bold;
        font-size: 16px;
        color: var(--color-main-text-primary);
        line-height: 24px;
    }

    .title-box {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100px;

        .title-name {
            position: relative;
            height: 38px;
            color: var(--color-main-text-primary);
            font-size: 24px;
            font-weight: 600;
            line-height: 38px;
        }
        .update-time {
            position: relative;
            display: flex;
            align-items: center;
            margin-top: 5px;
            color: var(--color-main-text-secondary);
            font-size: 14px;
            font-variant: tabular-nums;
            line-height: 1.66667;
        }
    }

    :deep(.msg-cont-md) {
        position: relative;
        display: flex;
        flex: 1;
        width: 100%;
        overflow: hidden;

        .md-editor-code-head {
            background-color: var(--color-main-md-code-bg) !important;
        }
        .md-editor-code pre code {
            background-color: var(--color-main-md-code-bg) !important;
        }
        .md-editor ::-webkit-scrollbar {
            width: var(--scrollbar-width);
        }

        .md-editor ::-webkit-scrollbar-track {
            background-color: var(--color-main-scrollbar-track-white);
            border-radius: unset;
        }

        .md-editor ::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: var(--color-main-scrollbar-thumb);
            box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
            -webkit-box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
        }
    }
    .msg-cont-md-empty {
        position: relative;
        display: flex;
        flex: 1;
        height: 100%;
        margin-top: -100px;
    }
}
</style>
